document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.section-header');

    // window.addEventListener('scroll', () => {
        
    //     if (window.scrollY > 0) {
    //         header.classList.add('scrolled');
    //     } else {
    //         header.classList.remove('scrolled');
    //     }
        
    // });
    
});


class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') {
      this.setAutoPlay()
      this.initNavProgress();
      this.initDragPause();
    };


  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.style.setProperty('--slide-duration', `${this.autoplaySpeed}ms`);

    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }

  
  }

  initDragPause() {
    let isDragging = false;

    this.slider.addEventListener('pointerdown', () => {
      isDragging = true;

      this.pause();

      const activeFill = this.querySelector('.progress-bar-fill.active .progress-bar-fill');

      this.querySelectorAll('.progress-bar-fill').forEach((fill) => {
        fill.style.animationPlayState = 'paused';
      });
    });


    this.slider.addEventListener('pointerup', () => {
      if (!isDragging) return;

      isDragging = false;

      setTimeout(() => {

        this.update();

        this.resetNavProgress();

        this.play();

      }, 100);
    });


    this.slider.addEventListener('pointercancel', () => {
      isDragging = false;

      this.resetNavProgress();
      this.play();
    });
  }

  resetNavProgress() {
    if (!this.navProgressContainer) return;

    const progressItems =
      this.navProgressContainer.querySelectorAll('.progress-item');

    const currentIndex = this.currentPage - 1;


    progressItems.forEach((item, index) => {
      const fill = item.querySelector('.progress-bar-fill');


      if (item.classList.contains('active')) {
        item.classList.remove('active');

        if (fill) {
          fill.style.animation = 'none';
        }
      }


      if (index === currentIndex) {

        item.classList.remove('idle');
        item.classList.add('active');

        if (fill) {
          void fill.offsetWidth;

          fill.style.animation =
            `fillProgress ${this.autoplaySpeed}ms linear forwards`;
        }

      }

    });
  }

  initNavProgress() {
    this.navProgressContainer = this.querySelector('#navProgress');
    if (!this.navProgressContainer) return;
    
    this.navProgressContainer.innerHTML = ''; 
    
    this.sliderItems.forEach((_, index) => {
      const progressItem = document.createElement('div');
      progressItem.classList.add('progress-item');
      
      const fill = document.createElement('div');
      fill.classList.add('progress-bar-fill');
      
      progressItem.appendChild(fill);
      this.navProgressContainer.appendChild(progressItem);
      
      progressItem.addEventListener('click', () => {
        const targetLink = this.sliderControlLinksArray[index];
        if (targetLink) targetLink.click();
      });
    });

    this.updateNavProgress();
  }

  updateNavProgress() {
    if (!this.navProgressContainer) return;
    const progressItems = this.navProgressContainer.querySelectorAll('.progress-item');
    const currentIndex = this.currentPage - 1;

    if (this.lastActiveIndex === currentIndex) return;
    this.lastActiveIndex = currentIndex;

    progressItems.forEach((item, index) => {
      const fill = item.querySelector('.progress-bar-fill');
      
      item.classList.remove('active', 'completed', 'idle');
      if (fill) fill.style.animation = 'none';

      if (index < currentIndex) {
        item.classList.add('completed');
      } else if (index === currentIndex) {
        void item.offsetWidth; 
        item.classList.add('active');
        if (fill) {
          fill.style.animation = `fillProgress ${this.autoplaySpeed}ms linear forwards`;
        }
      } else {
        item.classList.add('idle');
      }
    });
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    this.updateNavProgress();

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);






(function () {
  // -- reads the Foundation Check attribution flag, valid within the 7-day
  // attribution window (matches Klaviyo purchase attribution window) --
  function getFoundationCheckAttribution() {
    try {
      var raw = localStorage.getItem('fc_pending_attribution');
      if (!raw) return null;
      var attribution = JSON.parse(raw);
      var SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
      var withinWindow = (Date.now() - attribution.ts) < SEVEN_DAYS_MS;
      return withinWindow ? attribution : null;
    } catch (e) {
      return null;
    }
  }

  function buildAttributesPayload(fcAttribution) {
    return {
      _fc_result_type: fcAttribution.result_type || '',
      _fc_primary_theme: fcAttribution.primary_theme || '',
      _fc_secondary_theme: fcAttribution.secondary_theme || '',
      _fc_formula_flag: fcAttribution.formula_flag ? 'true' : 'false',
      _fc_consistency_flag: fcAttribution.consistency_flag ? 'true' : 'false',
      _fc_session_id: fcAttribution.session_id || '',
      _fc_visitor_id: fcAttribution.visitor_id || '',
      _fc_device_class: fcAttribution.device_class || '',
      _fc_entry_point: fcAttribution.entry_point || '',
      _fc_holdout: fcAttribution.holdout ? 'true' : 'false',
      _fc_new_visitor: fcAttribution.new_visitor ? 'true' : 'false',
      _fc_utm_source: fcAttribution.utm_source || '',
      _fc_utm_medium: fcAttribution.utm_medium || '',
      _fc_utm_campaign: fcAttribution.utm_campaign || '',
      _fc_landing_page: fcAttribution.landing_page || ''
    };
  }

  function trackAddedToCart(fcAttribution) {
    if (fcAttribution && window.FoundationCheck && typeof window.FoundationCheck.track === 'function') {
      window.FoundationCheck.track('foundation_check_added_to_cart', {
        result_type: fcAttribution.result_type,
        primary_theme: fcAttribution.primary_theme,
        secondary_theme: fcAttribution.secondary_theme,
        formula_flag: fcAttribution.formula_flag,
        consistency_flag: fcAttribution.consistency_flag
      });
    }
  }

  // -- global wrapper called from the Liquid onclick --
  // Each of these buttons is a "buy this now" action: the customer's
  // existing cart is cleared first, so checkout only ever contains the
  // single item they just clicked — never anything left over from an
  // earlier click or a previous session. We also bypass Booster's own
  // BoosterTheme.cart.addToCartJSON / addToCart entirely, because those
  // open the cart drawer OPTIMISTICALLY (before /cart/add even resolves).
  // That optimistic DOM mutation is what caused the drawer to reappear on
  // browser back/forward (bfcache had already captured it open) — calling
  // /cart/add.js ourselves means that drawer-opening code never runs.
  window.fcAddToCart = async function (event, variantId, quantity, sellingPlanId) {
    if (event && event.preventDefault) event.preventDefault();
    if (event && event.stopPropagation) event.stopPropagation();

    var fcAttribution = getFoundationCheckAttribution();

    var item;
    if (variantId) {
      item = { id: variantId, quantity: quantity || 1 };
      if (sellingPlanId) item.selling_plan = sellingPlanId;
    } else {
      // Fallback for buttons that don't pass a variantId directly (e.g.
      // quick-add modal forms) — read it straight from the surrounding form.
      var form = event && event.target && event.target.closest ? event.target.closest('form') : null;
      if (!form) {
        console.error('fcAddToCart: no variantId provided and no surrounding form found.');
        return;
      }
      var formData = new FormData(form);
      item = { id: formData.get('id'), quantity: formData.get('quantity') || 1 };
      var formSellingPlan = formData.get('selling_plan');
      if (formSellingPlan) item.selling_plan = formSellingPlan;
    }

    var payload = { items: [item] };
    if (fcAttribution) {
      payload.attributes = buildAttributesPayload(fcAttribution);
    }

    try {
      // Clear whatever's already in the cart BEFORE adding the clicked item.
      await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin'
      });
    } catch (clearError) {
      console.warn('Could not clear existing cart before add:', clearError);
      // We still attempt the add below even if clearing failed, rather than
      // silently doing nothing when the customer clicked a buy button.
    }

    // This goes through the patched window.fetch further down this file,
    // which handles attribution tracking and the redirect to checkout once
    // this add succeeds.
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).catch(function (err) {
      console.error('Add to cart request failed:', err);
    });
  };

  window.fcAddMonthlyIntroToCart = async function (event, variantId, quantity, sellingPlanId) {
    event.preventDefault();
    event.stopPropagation();

    if (!variantId || !sellingPlanId) {
      console.error('Monthly variant or selling plan is missing.');
      return;
    }

    try {
      await fetch(
        window.Shopify.routes.root + 'discount/AHFIRST20?redirect=' +
        encodeURIComponent(window.Shopify.routes.root),
        { method: 'GET', credentials: 'same-origin', redirect: 'follow', cache: 'no-store' }
      );
    } catch (discountError) {
      console.warn('Could not preload AHFIRST20:', discountError);
    }

    if (typeof window.fcAddToCart === 'function') {
      // fcAddToCart already clears the existing cart before adding this
      // item, so the monthly-intro flow gets the same "buy this now"
      // behaviour automatically.
      window.fcAddToCart(event, variantId, quantity, sellingPlanId);
    } else {
      console.error('fcAddToCart is not available.');
    }
  };

  // -- fallback watcher: catches any /cart/add request (including the one
  // fcAddToCart itself fires above), tracks Foundation Check attribution,
  // and redirects straight to checkout once the add succeeds. Also acts as
  // a safety net for any other /cart/add call elsewhere in the theme we
  // haven't wired through fcAddToCart directly. --
  if (!window.__fcCartWatcherInstalled) {
    window.__fcCartWatcherInstalled = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAddToCart = url.indexOf('/cart/add') !== -1;

      if (isAddToCart && init && typeof init.body === 'string') {
        try {
          var fcAttribution = getFoundationCheckAttribution();
          if (fcAttribution) {
            var bodyObj = JSON.parse(init.body);
            if (!bodyObj.attributes) {
              bodyObj.attributes = buildAttributesPayload(fcAttribution);
              init.body = JSON.stringify(bodyObj);
            }
          }
        } catch (e) {} // body wasn't JSON (e.g. FormData) — nothing to inject here
      }

      return originalFetch.call(this, input, init).then(function (response) {
        if (isAddToCart && response.ok) {
          var fcAttribution2 = getFoundationCheckAttribution();
          trackAddedToCart(fcAttribution2);

          // Redirect straight to checkout, and permanently stall this
          // promise chain so any success handler chained after us (e.g.
          // Booster's own drawer-opening code, on any add-to-cart path we
          // haven't fully bypassed) never runs after us.
          window.location.href = window.Shopify.routes.root + 'checkout';
          return new Promise(function () {}); // intentionally never resolves
        }
        return response;
      });
    };
  }
})();
